import { useState } from 'react'

import { customPost } from '../utils/customFetch.ts'
import TemplateOrganization from '../interfaces/TemplateOrganization.ts'
import { TempConsignment, TempFooter } from '../interfaces/TemplateDto.ts'
import { AppPath } from '../enums/AppPath.ts'

import { makeUrlTemplateConEdit, makeUrlTemplateDocsEdit, makeUrlTemplateGenEdit } from './connectionData.tsx'
import { useAuth } from './useAuth.tsx'

interface ApiParams {
  organizationId: string
  template: TemplateOrganization
}

interface ApiParamsCon {
  organizationId: string
  template: TempConsignment
}

interface ApiParamsDocs {
  organizationId: string
  template: TempFooter
}
const useTemplatePoster = () => {
  const [errorPostTemplate, setErrorPostTemplate] = useState<Error | null>(null)
  const [loadingPost, setLoadingPost] = useState<boolean>(false)
  const { userData } = useAuth()
  /*
    Modifica o crea la parte "general" del template
    */
  const postTemplateGen = async (template: TemplateOrganization) => {
    setLoadingPost(true)

    try {
      const apiUrl = makeUrlTemplateGenEdit()
      const apiParams: ApiParams = {
        organizationId: userData?.organization?._id ?? '',
        template: template,
      }

      const res = await customPost<{ _id: string }>(apiUrl, apiParams)
      setErrorPostTemplate(null)

      return res._id
    } catch (err) {
      // Assert the error as an instance of Error
      if (err instanceof Error) {
        setErrorPostTemplate(err)
      } else {
        setErrorPostTemplate(new Error('An unknown error occurred'))
      }

      return null
    } finally {
      setLoadingPost(false)
    }
  }
  // La parte de la consignacion
  const postTemplateCon = async (template: TempConsignment) => {
    setLoadingPost(true)

    try {
      const apiUrl = makeUrlTemplateConEdit()
      const apiParams: ApiParamsCon = {
        organizationId: userData?.organization?._id ?? '',
        template: template,
      }

      await customPost(apiUrl, apiParams)
      setErrorPostTemplate(null)

      return 'OK'
    } catch (err) {
      // Assert the error as an instance of Error
      if (err instanceof Error) {
        setErrorPostTemplate(err)
      } else {
        setErrorPostTemplate(new Error('An unknown error occurred'))
      }

      return null
    } finally {
      setLoadingPost(false)
    }
  }
  // La parte de la reserva o Cotizacion
  const postTemplateDocs = async (template: TempFooter, docType: AppPath) => {
    setLoadingPost(true)

    try {
      const apiUrl = makeUrlTemplateDocsEdit(docType)
      const apiParams: ApiParamsDocs = {
        organizationId: userData?.organization?._id ?? '',
        template: template,
      }

      await customPost(apiUrl, apiParams)
      setErrorPostTemplate(null)

      return 'OK'
    } catch (err) {
      // Assert the error as an instance of Error
      if (err instanceof Error) {
        setErrorPostTemplate(err)
      } else {
        setErrorPostTemplate(new Error('An unknown error occurred'))
      }

      return null
    } finally {
      setLoadingPost(false)
    }
  }

  // Exponemos estas variables al exterior
  return { errorPostTemplate, loadingPost, postTemplateGen, postTemplateCon, postTemplateDocs }
}
export default useTemplatePoster
